import React, { useContext } from 'react';
import EDStandardSelect from '../../../../../../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';
import { EkonomiskAnalysSideMenuContext } from '../../../Context/EkonomiskAnalysSideMenuContext';
import { EkonomiskAnalysContext } from '../../../../Context/EkonomiskAnalysContext';
import {
  budgetRadSummationMode,
  BudgetSummationModeType,
  budgetVerifikationSummationMode,
} from '../../../../../Utils/SummationModeUtils';

interface IProps {}

// const useStyles = makeStyles((theme: Theme) => {});

const EkonomiskAnalysBudgetSummationModeSelect: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  // const classes = useStyles();

  const { newAnalysSettings, onBudgetSummationModeChanged } = useContext(
    EkonomiskAnalysSideMenuContext
  );
  const { updateReport } = useContext(EkonomiskAnalysContext);

  return (
    <EDStandardSelect<BudgetSummationModeType>
      label="Visa budgetdetaljer per"
      value={newAnalysSettings.other.budgetSummationMode}
      items={[budgetVerifikationSummationMode, budgetRadSummationMode].map(
        sumMode => ({
          header: sumMode.displayName,
          value: sumMode,
        })
      )}
      onChange={value => {
        onBudgetSummationModeChanged(value);
        updateReport();
      }}
    />
  );
};

export default EkonomiskAnalysBudgetSummationModeSelect;
